import { CONTAINER_WIDTH_PRESETS, CONTAINER_WIDTH_WIDE_PX } from '../../constants/container-width';

const getContainerWidthClassValue = (value, customValue) => {
  switch (value) {
    case CONTAINER_WIDTH_PRESETS.WIDE:
      return `[${CONTAINER_WIDTH_WIDE_PX}px]`;
    case CONTAINER_WIDTH_PRESETS.FILL:
      return '[100%]';
    case CONTAINER_WIDTH_PRESETS.CUSTOM:
      return `[${customValue}px]`;
    default:
      return null;
  }
};

export default getContainerWidthClassValue;
